import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { debug } from 'util';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class DashbordService {

  myAppUrl: string = "";
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    //this.myAppUrl = baseUrl
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.myAppUrl = sessionStorage.getItem("BaseURL") || '';
    }
  }

  GetUserInformationbyid(TokenKey: string, userid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get(this.myAppUrl + "api/UserMaster/GetUserMasterFindByUserID/" + userid, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetPlanDocumentStatistics(TokenKey: string, userid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get(this.myAppUrl + "api/PlanDocument/PlanDocumentStatistics/" + userid, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetUserDocumentbyid(TokenKey: string, userid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get(this.myAppUrl + "api/UserDocument/GetUserDocumentFindByUserID/" + userid, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetRecentPlanbyid(TokenKey: string, userid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get(this.myAppUrl + "api/Plan/GetRecentPlanFindByUserID/" + userid, httpOptions)
      .pipe(catchError(this.handleError));
  }

  PlanChartbyUserid(TokenKey: string, userid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get(this.myAppUrl + "api/Plan/GeneratePlanChartByUserID/" + userid, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeletePlan(TokenKey: string, planid: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get(this.myAppUrl + "api/Plan/DeletePlan/" + planid, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }
}
